/**
 * Build-time configuration. Everything here is a constant folded at build time
 * so the mobile bundle physically lacks any payment surface or purchase call to
 * action (App Store guideline 3.1.1), rather than merely declining to render it
 * at runtime.
 */

export const BUILD_TARGET = __BUILD_TARGET__

/**
 * §13.2 difference 3 — the one genuinely divergent code path.
 * Web keeps the refresh token in an HttpOnly cookie (viable because app.scio.cz
 * and api.scio.cz share the registrable domain, §8.1); mobile uses bearer only.
 */
export const AUTH_STRATEGY: 'cookie' | 'bearer' = BUILD_TARGET === 'mobile' ? 'bearer' : 'cookie'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export const API_MODE = import.meta.env.VITE_API_MODE ?? 'http'

/** Sync engine tuning, §12.1 and §12.2. */
export const SYNC = {
  debounceMs: 2_000,
  maxBackoffMs: 30_000,
  baseBackoffMs: 500,
  maxAttempts: 12,
} as const
